function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.711 11.5042C20.6874 16.5602 16.5657 20.649 11.5079 20.6254C6.45007 20.6018 2.35978 16.4815 2.38338 11.4256C2.40698 6.36966 6.52873 2.28087 11.5865 2.30446C12.4124 2.30446 13.2384 2.42241 14.0407 2.65044L15.8263 0.865525C14.4576 0.28366 12.9867 -0.0151359 11.5 0.000590221C5.15219 0.000590221 0 5.15089 0 11.5042C0 17.8576 5.15219 23 11.5 23C17.8478 23 23 17.8497 23 11.5042H20.7031H20.711Z",
  fill: "#D9D9D9"
});

function SvgCircleOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleOutline);
export default __webpack_public_path__ + "static/media/circle-outline.b33eb5ea204076b163600e74e2e19fc9.svg";
export { ForwardRef as ReactComponent };